import React from 'react';
import * as Icon from 'react-bootstrap-icons';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import momencik from '../../../common/momencik';
import { GetReceiptDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import numberFormatter from '../../../common/numberFormatter';
import {
  PaymentFormEnumText,
  ReceiptTypeEnumText,
} from '../../../common/spdCore/validation/enums';
import { PrinterJpkDocumentPreviewLink } from '../PrinterJpkDocument/PrinterJpkDocumentPreviewLink';

interface ReceiptSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  withFilterInColumns?: boolean;
  showFilter?: boolean;
  withExamNumber?: boolean;
  withHistory?: boolean;
}

export const receiptForGrid = (receipt: GetReceiptDto): GridRecord => {
  return {
    key: receipt.id,
    values: {
      id: receipt.id,
      'receipt.systemNumber': receipt.systemNumber,
      'exam.number': receipt.exam?.number,
      receipt_type:
        ReceiptTypeEnumText[
          receipt.receiptType as keyof typeof ReceiptTypeEnumText
        ] || '',
      'receipt.receiptDate': momencik(receipt.receiptDate),
      'receipt.amountGross': numberFormatter(receipt.amountGross, true),
      payment_method:
        PaymentFormEnumText[
          receipt.paymentMethod as keyof typeof PaymentFormEnumText
        ] || '',
      'creator.name': receipt.creator?.name || '',
      'receipt.actions': (
        <>
          {receipt.fiscalized && (
            <Icon.CheckSquare
              className="text-success icon-green"
              title="Zafiskalizowany"
            />
          )}
          {receipt.printerJpkDocumentId && (
            <PrinterJpkDocumentPreviewLink
              printerJpkDocumentId={receipt.printerJpkDocumentId}
            />
          )}
        </>
      ),
    },
  };
};

export const ReceiptSearch: React.FC<ReceiptSearchProps> = props => {
  const columns: GridColumn[] = [
    { header: 'Nr sys.', property: 'receipt.systemNumber' },
    ...(props.withExamNumber
      ? [
          {
            header: 'Nr badania',
            property: 'exam.number',
          },
        ]
      : []),
    { header: 'Typ', property: 'receipt_type' },
    { header: 'Data wystawienia', property: 'receipt.receiptDate' },
    { header: 'Kwota brutto', property: 'receipt.amountGross' },
    {
      header: 'Forma płatności',
      property: 'payment_method',
    },
    { header: 'Wystawił', property: 'creator.name' },
    {
      header: '',
      property: 'receipt.actions',
      noFilter: true,
      noSorting: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={props.showFilter}
      initialOrderColumn="receipt.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={'Brak paragonów w systemie'}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={props.withHistory ?? true}
      withFilterInColumns={props.withFilterInColumns}
    />
  );
};
